export default __webpack_public_path__ + "static/media/collectable.8ee98bec.png";